
        import * as module0 from './controllers/daynight_controller.js';import * as module1 from './controllers/example_controller.js'
        const modules = {
            "./controllers/daynight_controller.js": module0,
            "./controllers/example_controller.js": module1,
        };
        export default modules;
      